<template>
    <div class="graybox">
        <div class="pvt_ltd_accordion" v-if="slug=='PvtLtd'">
            <pvt_accordion :no_of_directors="{dir:no_of_owners,date:new Date()}" :subscription_params="propstochild" @saveSuccessToparent="ShowSuccess"/>
        </div>
        <div class="sole" v-if="slug=='sole'">
            <sole_proprietorship_accordion  :subscription_params="propstochild" @saveSuccessToparent="ShowSuccess"/>
        </div>
        <div class="partnership_firm" v-if="slug=='PSF'">
            <partnership_firm_accordion :no_of_directors="{dir:no_of_owners}" :subscription_params="propstochild" @saveSuccessToparent="ShowSuccess"/>
        </div>
        <div class="opc" v-if="slug=='OPC'">
            <opc_accordion :subscription_params="propstochild" @saveSuccessToparent="ShowSuccess"/>
        </div>
        <div class="llp" v-if="slug=='LLP'" >
            <LLP_accordion :no_of_directors="{dir:no_of_owners}" :subscription_params="propstochild" @saveSuccessToparent="ShowSuccess"/>
        </div>

        <div class="submision_sucess" v-if="success">
            <p><b>Thank you for submitting the information sheet, your accounting manager will review and update your form soon.</b></p>
        </div>
	</div>
</template>
<script>
import summary from '../services/summary';
import pvt_accordion from './private_limited_accordion';
import sole_proprietorship_accordion from './sole_proprietorship_accordion';
import partnership_firm_accordion from './partnership_firm_accordion';
import opc_accordion from './opc_accordion';
import LLP_accordion from './LLP_accordion';

export default {
    name:'business_info',
    props:['subscription'],
     watch:{
       subscription: function (data){
           this.Savedata.subscribtion_id=data.id
                this.propstochild.subscribtion_id=data.id;
                this.propstochild.folder_id=data.folder.id;
                this.propstochild.type=data.type;
                this.propstochild.date=new Date();
                this.propstochild.company_info=data.company_info;
                this.slug=data.subscription.slug;
                this.no_of_owners=data.no_of_owners ? data.no_of_owners :2;
          
       }
    },
    components: {
        pvt_accordion,
        sole_proprietorship_accordion,
        partnership_firm_accordion,
        opc_accordion,
        LLP_accordion
    },
    data() {
        return {
            btn_text:'Submit',
            success:false,
            slug:"",
            no_of_owners:'',
            propstochild:{
                subscribtion_id:'',
                folder_id:'',
                type:'',
                date:'',
                company_info:{}
            },
            gst_present:false,
            Savedata:{
                name:'',
                pan_number:'',
                description:'',
                address:'',
                pin_code:'',
                city:'',
                state:'',
                gst_number:'',
                gst_reg:'',
            },
            formError:{
                 name:'',
                pan_number:'',
                description:'',
                address:'',
                pin_code:'',
                city:'',
                state:'',
                gst_reg:'',
                gst_number:'',
                subscribtion_id:''
            }
        }
    },
    methods: {
         toStr(str){
            if(str!=undefined && ( str!=[] || str!='' || str.length>0)){
                return str.join();
            }
            return str;
        },
        checkGst(type){
            this.gst_present = type=='yes' ? true :false;
        },
        SubmitForm(){
            summary.postInfo(this.Savedata)
            .then(response=>{
                 this.$notify({ group: 'auth', text: 'Successfully updated.', type: response.data.status })
            })
            .catch(error=>{
                var err= error.response.data;
                this.formError=err.errors
                return
            })
        },
        ShowSuccess(){
            this.success=true;
             setTimeout(function () {
                this.success=false 
            }.bind(this), 4000)
        }
    }
};

</script>